
  import AreYouSurePopup from '@/components/da-signer/AreYouSurePopup.vue'

  export default {
    name: `AeqDASigner`,
    components: {
      AreYouSurePopup
    },
    props: {
      label: {
        type: String,
        default: ``
      },
      pdfTemplate: {
        type: String,
        default: ``
      },
      value: {
        type: Object,
        default: undefined
      },
      errorMessages: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        elements: [],
        data: {},
        errors: {},
        accept: false,
        finalCheckbox: false,
        overlayInputValue: ``,
        inputHeight: 0,
        error: null,
        pdfUrl: null,
        imageUrl: null,
        step: 1,
        showModal: false,
        showAreYouSure: false,
        loading: false,
        name: null,
        signaturePullInterval: null,
        city: null,
        date: null,
        innerValue: this.initValue(this.value),
        buffer: null,
        errorPopup: false,
        cachedImageHeight: 0
      }
    },
    computed: {
      isSmallScreen() {
        return this.$vuetify.breakpoint.xsOnly
      },
      da() {
        return this.$store.getters[`daSigner/declarations`] || []
      },
      isDisabled() {
        return this.filteredProps?.disabled || false
      },
      requirements() {
        return { extensions: this.$config.public.images_extensions }
      },
      traductedErrors() {
        return this.$helpers.wrapInArray(this.errorMessages).map((e) => this.$t(e))
      },
      hasErrors() {
        return this.errorMessages?.length > 0
      },
      token() {
        return this.$router.history.current.query.token || this.$store.state.external.token
      }
    },
    mounted() {
      const parentObject = { $props: {} }
      this.filteredProps = Object.assign(parentObject.$props, this.$attrs)
      this.filteredProps.label = this.label
    },
    methods: {
      getFontSize(height) {
        // get the full height of the image, use cached height if available
        const documentHeight = this.$refs.imageContainer?.offsetHeight || this.cachedImageHeight || 0
        if (!documentHeight) {
          return `12px`
        }
        return documentHeight * (height / 100) * 0.6 + `px`
      },
      cacheImageHeight() {
        if (this.$refs.imageContainer) {
          this.cachedImageHeight = this.$refs.imageContainer.offsetHeight
        }
      },
      removeSignaturePullListener() {
        clearInterval(this.signaturePullInterval)
      },
      clearValues() {
        this.signature = null
        this.name = null
        this.city = null
        this.accept = false
        this.finalCheckbox = false
        this.pdfUrl = null
        this.step = 1
        this.errors = {}
        this.buffer = null
        this.cachedImageHeight = 0
      },
      initValue(value) {
        if (value) {
          if (!value.new) {
            value.new = []
          }
          if (!value.saved) {
            value.saved = []
          }
        } else {
          value = { new: [], saved: [] }
        }
        return JSON.parse(JSON.stringify(value))
      },
      getDocumentList() {
        let newDocs = []
        if (this.innerValue.new.length !== 0) {
          newDocs = [
            {
              sourceIndex: 0,
              size: this.innerValue.new[0].size,
              fileName: this.innerValue.new[0].name,
              downloadLink: false,
              deleteLink: false,
              deletable: true,
              data: this.innerValue.new[0].content
            }
          ]
        }
        return newDocs.concat(
          this.innerValue.saved.map((f, i) => ({
            sourceIndex: i,
            ...f
          }))
        )
      },
      async openModal() {
        this.clearValues()
        this.showModal = true
        const data = await this.$store.dispatch(`customPDF/getElements`, { pdfTemplate: this.pdfTemplate })
        this.elements = data.elements
        this.imageUrl = data.image
      },
      deleteAndOpenModal() {
        this.innerValue.saved.forEach((doc) => {
          this.deleteDocument(doc)
        })
        this.innerValue.new = []
        this.showAreYouSure = false
        this.openModal()
      },
      areYouSure() {
        if (this.getDocumentList().length > 0) {
          this.showAreYouSure = true
          return
        }
        this.openModal()
      },
      closeModal() {
        this.cacheImageHeight()
        this.showModal = false
        this.clearValues()
        this.removeSignaturePullListener()
      },
      refreshComponent(doc = null, emitBlur = true, emitInput = true) {
        if (doc) {
          this.innerValue = this.initValue(doc)
          if (emitBlur) {
            this.$emit(`blur`, doc)
          }
        }
        if (emitInput) {
          this.$emit(`input`, this.innerValue)
        }
        this.refreshCounter += 1
      },
      async deleteDocument(doc) {
        if (doc.deleteLink) {
          const deleteLinkWithoutApi = doc.deleteLink.replace(/frontoffice/, ``).replace(`//`, ``)
          console.log(deleteLinkWithoutApi)
          await this.$api.documents
            .delete(deleteLinkWithoutApi)
            .then(() => {
              this.innerValue.saved.splice(doc.sourceIndex, 1)
              this.$flashMessage.success({
                title: `${this.$t(`messages.success`)}`,
                message: this.$t(`messages.document_delete`)
              })
            })
            .catch(() => {
              this.$flashMessage.error({
                title: `<${this.$options.name}> : ${this.$t(`messages.error`)}`,
                message: this.$t(`messages.cant_delete_document`)
              })
            })
            .finally(() => this.refreshComponent())
        } else {
          this.innerValue.new.splice(doc.sourceIndex, 1)
          this.refreshComponent()
        }
      },
      onCloseModal(isOpen) {
        if (!isOpen) {
          this.clearValues()
        }
      },
      async nextStep() {
        if (this.step === 1) {
          this.cacheImageHeight()
          this.step++
          await this.generatePDF()
        }
      },
      prevStep() {
        if (this.step > 1) {
          this.step--
        }
      },
      submit() {
        this.innerValue.new = this.buffer
        this.$emit(`input`, this.innerValue)
        this.$emit(`change`, this.innerValue)
        this.showModal = false
      },
      getDocName() {
        return this.$i18n.t(`components.custom_pdf.doc_name`) + `.pdf`
      },
      serializeDoc(blobContent) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = () => {
            console.log(blobContent)
            console.log(reader)
            resolve({
              size: blobContent.size,
              name: this.getDocName(),
              deletable: false,
              content_type: blobContent.type,
              content: reader.result
            })
          }
          reader.readAsDataURL(blobContent)
        })
      },
      dataURLtoBlob(dataURL) {
        const byteString = atob(dataURL.split(`,`)[1])
        const mimeString = dataURL.split(`,`)[0].split(`:`)[1].split(`;`)[0]
        const arrayBuffer = new ArrayBuffer(byteString.length)
        const uint8Array = new Uint8Array(arrayBuffer)
        for (let i = 0; i < byteString.length; i++) {
          uint8Array[i] = byteString.charCodeAt(i)
        }
        return new Blob([arrayBuffer], { type: mimeString })
      },
      async generatePDF() {
        this.pdfUrl = null
        let response
        this.errors = {}
        try {
          response = await this.$store.dispatch(`customPDF/generatePDF`, { code: this.pdfTemplate, data: this.data })
        } catch (error) {
          // show message with errors
          this.$flashMessage.error({
            title: `${this.$t(`messages.error`)}`,
            message: this.$t(`components.custom_pdf.invalid_fields`)
          })

          this.errors = error.response?._data?.elements || {}
          this.step--
          return
        }
        const newBlob = new Blob([response], { type: `application/pdf` })
        this.pdfUrl = URL.createObjectURL(newBlob) + `#toolbar=0&navpanes=0`
        this.buffer = [await this.serializeDoc(newBlob)]
        this.loading = false
      }
    }
  }
